import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaPhone, FaWhatsapp } from 'react-icons/fa';
import './ContactSection.css';

const ContactSection = () => {
  const { t } = useTranslation();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá, gostaria de receber atendimento.');
    window.open(`https://wa.me/5511933728770?text=${message}`, '_blank');
  };

  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <h2 className="section-title">{t('contact.title')}</h2>
        <p className="section-subtitle">
          {t('contact.subtitle')}
        </p>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-cards">
              <div className="info-card">
                <FaEnvelope className="info-icon" />
                <h4>{t('contact.info.email.title')}</h4>
                <p>{t('contact.info.email.content')}</p>
              </div>
              <div className="info-card">
                <FaPhone className="info-icon" />
                <h4>{t('contact.info.phone.title')}</h4>
                <p>{t('contact.info.phone.content')}</p>
              </div>
            </div>
            <button onClick={handleWhatsAppClick} className="contact-whatsapp-button">
              <FaWhatsapp /> Fale Conosco Agora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
